import { Inject, Injectable } from '@angular/core';
import { IfFeatureService } from '../if-feature/if-feature.service';

import {
  ModalId,
  ModalTriggerConfiguration,
  ModalType,
  MODAL_NOTIFICATION_CONFIGURATION,
  TriggerConfiguration,
  TriggerLinkIdType,
  TriggerType
} from './modal-notification.domain';

@Injectable({
  providedIn: 'root'
})
export class ModalNotificationMultipleService {

  private static readonly FEATURE_FLAG: string = 'multipleWhatsNewModal';

  constructor(private featureService: IfFeatureService,
              @Inject(MODAL_NOTIFICATION_CONFIGURATION)
              private triggerConfiguration: TriggerConfiguration) {
  }

  hasMultipleWhatsNewModal(): boolean {
    return this.featureService.getFeatureFlag(ModalNotificationMultipleService.FEATURE_FLAG) &&
      Object.values(this.triggerConfiguration)[0]?.modalType === ModalType.WHATS_NEW;
  }

  getMultipleWhatsNewModal(): Array<ModalTriggerConfiguration> {
    const modals = Object.values(this.triggerConfiguration);
    const allWhatsNew = modals.filter((config: ModalTriggerConfiguration) => config.modalType === ModalType.WHATS_NEW);
    return allWhatsNew.slice(0, 3);
  }

  getMultipleWhatsNewTrigger(): ModalTriggerConfiguration {
    return {
      id: ModalId.WHATS_NEW,
      triggerLinkId: TriggerLinkIdType.ANY_URL,
      persistence: TriggerType.PER_USER,
      modalType: ModalType.WHATS_NEW
    };
  }
}
